import { render, staticRenderFns } from "./PublicationDonations.vue?vue&type=template&id=d54467d4&scoped=true&"
import script from "./PublicationDonations.vue?vue&type=script&lang=js&"
export * from "./PublicationDonations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d54467d4",
  null
  
)

export default component.exports